import React from 'react'

import { Typography, Grid, Box, Card } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import { useDispatch } from 'react-redux'
import styles from '../settingsStyles'
import { trackEvent } from '../../../helpers/analytics'
import useSettingsBack from '../../../helpers/useSettingsBack'
import BackButtonNavBar from '../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'

function Copyrights() {
  const classes = styles()
  const dispatch = useDispatch()
  const goBackButton = useSettingsBack('Copyrights', '/settings/appinfo')
  return (
    <Box className={classes.settingsNavBar}>
      <BackButtonNavBar
        onClick={goBackButton}
        name="Copyright Information"
        topMargin={{ xs: 56, sm: 64, md: 64, lg: 64 }}
      />
      <Box className={classes.centerPage}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          <Grid item className={classes.fullWidth}>
            <Card className={classes.linksCard}>
              <Grid
                container
                direction="column"
                alignItems="left"
                justifyContent="flex-start"
              ></Grid>
              <Grid item>
                <Typography variant="h6">
                  <Link
                    href="https://www.rutgers.edu/copyright-information"
                    target="_blank"
                    rel="noopener noreferer"
                    onClick={() =>
                      trackEvent(dispatch, {
                        eventName: 'uxp_external_link_click',
                        module: 'Settings',
                        object: 'External Link',
                        action: 'Click',
                        actionContext: 'Copyright',
                        actionContextValue:
                          'https://www.rutgers.edu/copyright-information',
                      })
                    }
                  >
                    Copyright ©
                  </Link>{' '}
                  <Link
                    href="https://www.rutgers.edu"
                    target="_blank"
                    rel="noopener noreferer"
                    onClick={() =>
                      trackEvent(dispatch, {
                        eventName: 'uxp_external_link_click',
                        module: 'Settings',
                        object: 'ExternalLink',
                        action: 'Click',
                        actionContext: 'Copyright',
                        actionContextValue: 'https://www.rutgers.edu',
                      })
                    }
                  >
                    Rutgers, The State University of New Jersey. All rights
                    reserved.
                  </Link>
                </Typography>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default Copyrights
